import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {WidgetData} from "../../../../../core/shared/widget/widget-data";
import {DtoImportObjectContext} from "../../../../../core/shared/dto/dto.import.object.context";
import {WidgetFactory} from "../../../../../core/shared/widget/service/widget.factory";
import {Sorting} from "../../../../../core/shared/misc/sorting";
import {ObjectIdentifier} from "../../../../../core/shared/basic/object-identifier";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";
import {WidgetDataParam} from "../../../../../core/shared/widget/widget-data-param";
import {WidgetToolbarCallbackInterface} from "../../../../../core/shared/widget/widget-toolbar-callback.interface";
import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";
import {MvsFormControlOverwrite} from "../../../../../core/shared/logic/form/logic/mvs-form-control-overwrite";
import {MvsFormFieldAccessEnum} from "../../../../../core/shared/logic/form/logic/mvs-form-field-access.enum";

@Component({
    selector: 'mvs-te-test-case-setup',
    templateUrl: './te-test-case-setup.component.html',
    styleUrls: ['./te-test-case-setup.component.scss'],
    standalone: false
})
export class TeTestCaseSetupComponent implements OnInit, OnChanges, OnDestroy {

  busy: boolean;  // indicator whether the component is busy
  initialized: boolean; // indicator whether the component was initialized


  widgetTestCases: WidgetData;
  widgetTestCaseVariables: WidgetData;

  importContext: DtoImportObjectContext;

  ngOnInit(): void {
    this.initComponent();
  }

  /**
   * Initialize Component.
   */
  initComponent() {

    //create widget for test cases
    // this.widgetTestCases = WidgetFactory.createWidgetListEntity(
    //     "te.test.case.setup.test.cases",
    //     "Test Cases",
    //     "te.TeTestCase",
    //     "Keine Test Cases vorhanden",
    //     ObjectRequestList.createBasic(true, null, [new Sorting("name", true)])
    // );
    //
    // this.widgetTestCases = WidgetFactory.createWidgetList(
    //     'te.test.case.setup.test.cases',
    //     "Test Cases",
    //     'selectable',
    //     'list',
    //     'entity',
    //     'te.TeTestCase',
    //     'Keine Test Cases vorhanden',
    //     ObjectRequestList.createBasic(true, null, [new Sorting("name", true)])
    // );
      this.widgetTestCases = WidgetFactory.createWidgetSelectableEntityQl(
          'te.test.case.setup.test.cases.new',
          'Test Cases',
          'te.TeTestCase',
          'Keine Test Cases vorhanden',
          [],
          [
              new Sorting("e.name", true)
          ],
          WidgetDataParam.create('attributeToDisplay', 'e.name')
      );


      this.initialized = true;

  }

  handleTestCaseSelect(event: ObjectIdentifier) {

    this.importContext = DtoImportObjectContext.createFromObjectIdentifier(event);

    // this.widgetTestCaseVariables = WidgetFactory.createWidgetListEntity(
    //     "te.test.case.setup.test.case.variables",
    //     "Variablen",
    //     "te.TeTestCaseVariable",
    //     "Keine Variablen gefunden",
    //     ObjectRequestList.createBasic(
    //         true,
    //         [FilterCriteria.create("testCase", FilterCriteria.cOperatorEqual, event.objectId)],
    //         [new Sorting("name", true)]
    //     )
    // );
      this.widgetTestCaseVariables = WidgetFactory.createWidgetListEntityQl("te.test.case.setup.test.case.variables", "Variablen", "te.TeTestCaseVariable", "Keine Variablen gefunden", [
          FilterCriteria.create(
              "e.testCaseId",
              FilterCriteria.cOperatorEqual,
              event.objectId
          )
      ], [
          new Sorting("e.name", true)
      ]);

      // FIX: Default the selected test case when creating a new variable, and lock the field as read-only
      this.widgetTestCaseVariables.functionCallbacks = {
          onFunctionCreateNew: (widgetData: WidgetData): WidgetToolbarCallbackInterface => {
              const dto = new DtoDetail();
              dto['testCaseDtoId'] = event.objectId;
              const formControlOverwrite = new MvsFormControlOverwrite();
              formControlOverwrite.addField('testCaseDtoId', MvsFormFieldAccessEnum.READ);
              return {
                  dto: dto,
                  formControlOverwrite: formControlOverwrite,
              };
          },
      };


  }



  /**
   * Process changes within Binding.
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {

    if (!this.initialized) {
      return;
    }

  }

  /**
   * Destroy component.
   */
  ngOnDestroy(): void {

  }
}
